import Vuex from 'vuex';
import Vue from "vue";
import api from "./services/groupsPlaceApi";
import gpCookie from './services/gpCookie';
import Router from "./router";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    userDetails: {name: "Guest",
      groups: [],
      visited: [],
      visitedEvents: [],
      tosAgreed: true,
      billingSuspension: false
    },
    apiKey: null,
    secret: null,
    loggedIn: false,
    notifications: -1,
    currentGroup: null,
    executing: false,
    detailsLoadedStamp: null,
    diagnosticMode: false,
    toDos: [],
    settings: { disableGroupSubscriptions: false, newGroupApproval: true, features: [],
      labels: { },
    },
    dataTableReloadEvent: false,
    insertTableRow: null,
    updateTableRow: null,
    deleteTableRow: null,
    cognitoAuth: null,
    language: "en",
    translationMode: false
  },
  mutations: {
    SET_LOGGED_IN: (state, newValue) => {
      state.loggedIn = newValue;
    },
    SET_API_KEY: (state, newValue) => {
      state.apiKey = newValue;
    },
    SET_SECRET: (state, newValue) => {
      state.secret = newValue;
    },
    SET_SETTINGS: (state, newValue) => {
      state.settings = newValue;
    },
    SET_EXECUTING: (state, newValue) => {
      state.executing = newValue;
    },
    SET_USER_DETAILS: (state, newValue) => {
      state.userDetails = newValue;
      state.detailsLoadedStamp = new Date();
    },
    SET_NOTIFICATION_COUNT: (state, newValue) => {
      state.notifications = newValue;
    },
    SET_TO_DOS: (state, newValue) => {
      state.toDos = newValue;
    },
    SET_CURRENT_GROUP: (state, newValue) => {
      if (!newValue) return;
      if (!state.currentGroup || (state.currentGroup && state.currentGroup.id != newValue.id)) {
        state.currentGroup = newValue;
      }
    },
    SET_AVATAR: (state, newValue) => {
      state.userDetails.avatar = newValue;
      state.userDetails.hasAvatar = true;
      state.userDetails.requireAvatar= false;
    },
    SET_PROFILE_REVIEW: (state, newValue) => {
      state.userDetails.needProfileReview = newValue;
    },
    SET_GROUP_BALANCE: (state, newValue) => {
      state.currentGroup.balance = newValue;
    },
    SET_DATA_TABLE_RELOAD: (state, newValue) => {
      state.dataTableReloadEvent = newValue;
    },
    SET_INSERT_TABLE_ROW: (state, newValue) => {
      state.insertTableRow = newValue;
    },
    SET_COGNITO_AUTH: (state, newValue) => {
      state.cognitoAuth = newValue;
    },
    SET_UPDATE_TABLE_ROW: (state, newValue) => {
      state.updateTableRow = newValue;
    },
    SET_DELETE_TABLE_ROW: (state, newValue) => {
      state.deleteTableRow = newValue;
    },
    TOGGLE_DIAGNOSTIC_MODE: state => {
      state.diagnosticMode = !state.diagnosticMode;
      if (state.diagnosticMode) localStorage.setItem("diagnosticMode",true);
      else localStorage.removeItem("diagnosticMode");
    },
    TOGGLE_BANNER: state => {
      if (state.currentGroup) state.currentGroup.homePageBanner = !state.currentGroup.homePageBanner
    },
    SET_TRANSLATION_MODE: (state, newValue) => {
      state.translationMode = newValue;
    },
    SET_LANGUAGE: (state, newValue) => {
      state.language = newValue;
    },
  },
  getters: {
    apiKey: state => {
      return state.apiKey;
    },
    secret: state => {
      return state.secret;
    },
    currentGroup: state => {
      return state.currentGroup;
    },
    currentUser: state => {
      return state.userDetails;
    },
    settings: state => {
      return state.settings;
    }
  },
  actions: {
    setApiKey: ({commit, state}, newValue) => {
      commit('SET_API_KEY', newValue);
      return state.apiKey;
    },
    setSecret: ({commit, state}, newValue) => {
      commit('SET_SECRET', newValue);
      return state.secret;
    },
    setCognitoAuth: ({commit, state}, newValue) => {
      commit('SET_COGNITO_AUTH', newValue);
      return state.cognitoAuth;
    },
    setToDos: ({commit, state}, newValue) => {
      commit('SET_TO_DOS', newValue);
      return state.apiKey;
    },
    setSettings: ({commit, state}, newValue) => {
      commit('SET_SETTINGS', newValue);
      if (newValue.favIcon) {
           document.querySelector("link[rel*='icon']").href = newValue.favIcon;
      }
      if (newValue.siteName) document.title = newValue.siteName
      if (typeof newValue.metaProperties != "undefined") {
        for (const m of newValue.metaProperties) {
          let meta = document.createElement('meta');
          if (m.property == "description") {
            meta.name = m.property
            meta.content = m.content
          } else {
            meta.setAttribute("property", m.property)
            meta.content = m.content
          }
          document.getElementsByTagName('head')[0].appendChild(meta);
        }
      }
      return state.settings;
    },
    setLoggedIn: ({commit, state}, newValue) => {
      commit('SET_LOGGED_IN', newValue);
      return state.loggedIn;
    },
    setUserDetails: ({commit, state}, newValue) => {
      commit('SET_USER_DETAILS', newValue);
      return state.userDetails;
    },
    setNotificationCount: ({commit, state}, newValue) => {
      commit('SET_NOTIFICATION_COUNT', newValue);
      return state.notifications;
    },
    setCurrentGroup: ({commit, state}, newValue) => {
      commit('SET_CURRENT_GROUP', newValue);
      if (newValue && newValue.avatar) {
        document.querySelector("link[rel*='icon']").href = newValue.avatar;
      }
      return state.currentGroup;
    },
    setExecuting: ({commit, state}, newValue) => {
      commit('SET_EXECUTING', newValue);
      return state.executing;
    },
    setAvatar: ({commit, state}, newValue) => {
      commit('SET_AVATAR', newValue);
      return state.userDetails.avatar;
    },
    setDataTableReload: ({commit, state}, newValue) => {
      commit('SET_DATA_TABLE_RELOAD', newValue);
      return state.dataTableReloadEvent;
    },
    updateTableRow: ({commit, state}, newValue) => {
      commit('SET_UPDATE_TABLE_ROW', newValue);
      return state.updateTableRow;
    },
    deleteTableRow: ({commit, state}, newValue) => {
      commit('SET_DELETE_TABLE_ROW', newValue);
      return state.deleteTableRow;
    },
    insertTableRow: ({commit, state}, newValue) => {
      commit('SET_INSERT_TABLE_ROW', newValue);
      return state.insertTableRow;
    },
    setProfileReview: ({commit, state}, newValue) => {
      commit('SET_PROFILE_REVIEW', newValue);
      return state.userDetails.needProfileReview;
    },
    toggleDiagnosticMode: ({commit, state}) => {
      commit('TOGGLE_DIAGNOSTIC_MODE');
      return state.diagnosticMode;
    },
    toggleBanner: ({commit, state}) => {
      commit('TOGGLE_BANNER');
      return state.currentGroup.homePageBanner;
    },
    logout: ({commit, state}) => {
      let saveKey = state.apiKey
      let saveSecret = state.secret
      if (saveKey && saveSecret) api.logout(saveKey, saveSecret)
      commit("SET_LOGGED_IN", false);
      commit("SET_USER_DETAILS", {name: "Guest",
        groups: [],
        visited: [],
        visitedEvents: [],
        tosAgreed: true,
        billingSuspension: false,
        loggingOut: true
      });
      commit("SET_CURRENT_GROUP", null);
      localStorage.removeItem("apiKey");
      localStorage.removeItem("secret");
      gpCookie.deleteCookie("JSESSIONID");
      gpCookie.deleteCookie("groups-place-remember-me");
      try {
        if (state.cognitoAuth) {
          console.log("Performing Cognito Signout", state.cognitoAuth.getFQDNSignOut())
          state.cognitoAuth.signOut()
          store.dispatch("setCognitoAuth", null)
          if (Router.currentRoute.path != "/") {
            Router.push("/");
          }
        }
        else {
          if (Router.currentRoute.path != "/") {
            Router.push("/");
          }
        }
      }
      catch (e) { }


    },
    updateGroupBalance: ({commit, state}) => {
      api.get("/group/balance/" + state.currentGroup.vanityPath).then(
        results => {
          commit('SET_GROUP_BALANCE', results.data.balance);
        },
        error => {
          console.log("Error updating group balance.",error)
        });
    },
    setTranslationMode: ({commit, state}, newValue) => {
      commit('SET_TRANSLATION_MODE', newValue);
      return state.translationMode;
    },
    setLanguage: ({commit, state}, newValue) => {
      if (!newValue) return state.language
      if (newValue == undefined || newValue == "undefined") return state.language
      commit('SET_LANGUAGE', newValue);
      return state.language;
    }
  }
}
);

